import { createFileRoute, redirect } from '@tanstack/react-router'
import React from 'react'
import { MissedCandidatesTable } from '../candidate/components/missed-candidates-table'
import { SHOW_CANDIDATE } from '../user/permission'

export const Route = createFileRoute('/_auth/_main/campaigns/$campaignId/settings/missed-candidates')({
    beforeLoad: ({ context }) => {
        if (!context.auth.hasSubscription || !context.auth.can(SHOW_CANDIDATE)) {
            throw redirect({ to: '/dashboard' })
        }
    },
    component: CampaignSettingsMissedCandidates,
})

function CampaignSettingsMissedCandidates() {
    const { campaignId } = Route.useParams()

    return <MissedCandidatesTable campaignId={campaignId} />
}
